// Entity types a label can be scoped to. A label with no categories is global —
// assignable to any surface. Keep in sync with `Label::CATEGORIES` in the backend
// (app/models/label.rb).
export const LABEL_CATEGORIES = [
  { key: 'conversation', i18nKey: 'LABEL_MGMT.CATEGORIES.OPTIONS.CONVERSATION' },
  { key: 'contact', i18nKey: 'LABEL_MGMT.CATEGORIES.OPTIONS.CONTACT' },
  {
    key: 'calendar_event',
    i18nKey: 'LABEL_MGMT.CATEGORIES.OPTIONS.CALENDAR_EVENT',
  },
  { key: 'reminder', i18nKey: 'LABEL_MGMT.CATEGORIES.OPTIONS.REMINDER' },
];

// A label is available for a surface when it is global (no categories) or its
// categories include that surface's category.
export const isLabelInCategory = (label, category) =>
  !label?.categories?.length || label.categories.includes(category);

// Filter a list of labels down to the ones assignable on the given surface.
export const filterLabelsByCategory = (labels, category) =>
  (labels || []).filter(label => isLabelInCategory(label, category));
